import React from "react";
import ShopperApproveLogo from "./shopper-approve-logo-wide.svg";
const SHOPPER_APPROVE_LOGO = "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/Shopper_Approved_Logo.svg?v=1781281213";

const RATING_DISTRIBUTION = [
    { label: "5", value: "129.8k", count: 129800 },
    { label: "4", value: "19k", count: 19000 },
    { label: "3", value: "4.6k", count: 4600 },
    { label: "2", value: "1.5k", count: 1500 },
    { label: "1", value: "4.8k", count: 4800 },
];

const ShopperApproveStars = () => (
    Array.from({ length: 5 }).map((_, index) => (
        <svg key={index} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <g clipPath="url(#clip0_21402_3953)">
                <path d="M7.63373 1.52151C7.66276 1.46286 7.7076 1.41349 7.7632 1.37898C7.81879 1.34446 7.88293 1.32617 7.94837 1.32617C8.0138 1.32617 8.07794 1.34446 8.13354 1.37898C8.18913 1.41349 8.23397 1.46286 8.263 1.52151L9.79313 4.62085C9.89393 4.82484 10.0427 5.00133 10.2268 5.13516C10.4108 5.269 10.6245 5.35618 10.8496 5.38922L14.2716 5.88999C14.3364 5.89938 14.3973 5.92673 14.4474 5.96895C14.4975 6.01116 14.5348 6.06655 14.5551 6.12885C14.5754 6.19116 14.5778 6.25789 14.5621 6.3215C14.5464 6.38511 14.5132 6.44306 14.4663 6.48879L11.9916 8.89858C11.8284 9.05762 11.7063 9.25394 11.6358 9.47064C11.5653 9.68734 11.5485 9.91793 11.5869 10.1426L12.1711 13.5473C12.1826 13.6121 12.1756 13.6788 12.1509 13.7398C12.1263 13.8008 12.085 13.8537 12.0317 13.8924C11.9785 13.931 11.9154 13.954 11.8498 13.9585C11.7841 13.9631 11.7185 13.9491 11.6604 13.9182L8.60149 12.3099C8.39993 12.2041 8.17569 12.1488 7.94804 12.1488C7.72038 12.1488 7.49614 12.2041 7.29458 12.3099L4.23631 13.9182C4.17824 13.9489 4.11271 13.9628 4.04717 13.9581C3.98163 13.9534 3.91871 13.9305 3.86557 13.8918C3.81243 13.8532 3.7712 13.8004 3.74658 13.7395C3.72195 13.6786 3.71492 13.612 3.72627 13.5473L4.30984 10.1432C4.34839 9.91849 4.33169 9.68775 4.26118 9.47092C4.19067 9.25408 4.06847 9.05766 3.90512 8.89858L1.43042 6.48946C1.38312 6.44377 1.3496 6.38572 1.33368 6.32192C1.31777 6.25812 1.32009 6.19113 1.34038 6.12858C1.36068 6.06603 1.39814 6.01044 1.44849 5.96814C1.49883 5.92584 1.56005 5.89853 1.62516 5.88933L5.04642 5.38922C5.27181 5.35643 5.48585 5.26937 5.67012 5.13552C5.85439 5.00167 6.00338 4.82504 6.10426 4.62085L7.63373 1.52151Z" fill="#EB7100" stroke="#EB7100" strokeWidth="1.32479" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_21402_3953">
                    <rect width="15.8974" height="15.8974" fill="white" />
                </clipPath>
            </defs>
        </svg>
    ))
);

const ShopperApproveRatingDistribution = () => {
    const maxCount = Math.max(...RATING_DISTRIBUTION.map((item) => item.count));

    return (
        <div className="shopper-approve-card__distribution">
            {RATING_DISTRIBUTION.map((item) => (
                <div key={item.label} className="shopper-approve-card__distribution-row">
                    <span>
                        {item.label}
                        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="8" viewBox="0 0 9 8" fill="none">
                            <path d="M4.16455 0.122904C4.1837 0.0860029 4.2133 0.0549415 4.24999 0.0332246C4.28668 0.0115078 4.329 0 4.37219 0C4.41537 0 4.4577 0.0115078 4.49439 0.0332246C4.53108 0.0549415 4.56067 0.0860029 4.57983 0.122904L5.58962 2.07298C5.65615 2.20134 5.75434 2.31238 5.87579 2.39659C5.99723 2.48079 6.13829 2.53565 6.28686 2.55644L8.54513 2.87152C8.58792 2.87743 8.62812 2.89464 8.66118 2.9212C8.69425 2.94776 8.71886 2.98261 8.73223 3.02181C8.7456 3.06101 8.7472 3.103 8.73685 3.14302C8.7265 3.18304 8.7046 3.2195 8.67365 3.24828L7.04049 4.7645C6.93279 4.86457 6.8522 4.98809 6.80567 5.12444C6.75915 5.26078 6.74807 5.40587 6.7734 5.5472L7.15896 7.68941C7.16651 7.73019 7.16189 7.77217 7.14562 7.81056C7.12935 7.84895 7.1021 7.88222 7.06696 7.90655C7.03182 7.93088 6.99021 7.94531 6.94688 7.94818C6.90356 7.95106 6.86026 7.94226 6.82192 7.9228L4.80321 6.91088C4.67019 6.84429 4.52221 6.8095 4.37197 6.8095C4.22173 6.8095 4.07374 6.84429 3.94073 6.91088L1.92245 7.9228C1.88413 7.94215 1.84088 7.95085 1.79763 7.94792C1.75438 7.94499 1.71285 7.93054 1.67779 7.90623C1.64272 7.88191 1.61551 7.8487 1.59926 7.81037C1.58301 7.77204 1.57836 7.73013 1.58586 7.68941L1.97098 5.54762C1.99642 5.40622 1.9854 5.26104 1.93886 5.12461C1.89233 4.98818 1.81169 4.86459 1.70388 4.7645L0.0707291 3.2487C0.0395146 3.21996 0.0173951 3.18343 0.00689026 3.14329C-0.00361455 3.10314 -0.00208226 3.06099 0.0113125 3.02164C0.0247073 2.98228 0.049426 2.94731 0.0826529 2.92069C0.11588 2.89408 0.156279 2.8769 0.199248 2.8711L2.45708 2.55644C2.60582 2.53581 2.74707 2.48103 2.86868 2.39681C2.99029 2.31259 3.08861 2.20146 3.15519 2.07298L4.16455 0.122904Z" fill="black" />
                        </svg>
                    </span>
                    <div className="shopper-approve-card__distribution-bar">
                        <div
                            className="shopper-approve-card__distribution-bar-fill"
                            style={{ width: `${(item.count / maxCount) * 90}%` }}
                        />
                    </div>
                    <span>{item.value}</span>
                </div>
            ))}
        </div>
    );
};

const ShopperApproveCardDesktop = () => (
    <a href="https://www.shopperapproved.com/reviews/15622" target="_blank" className="shopper-approve-card shopper-approve-card--desktop">
        <div>

            <div className="shopper-approve-card__image">
                <img src={ShopperApproveLogo} alt="Shopper Approved" />
            </div>
            <div className="shopper-approve-card__content">
                <div className="shopper-approve-card__score">
                    4.7 <span>/ 5</span>
                </div>
                <div className="shopper-approve-card__stars-container">
                    <div className="shopper-approve-card__stars">
                        <ShopperApproveStars />
                    </div>
                    <p className="shopper-approve-card__reviews-count">Based on 159k+ Reviews</p>
                </div>
            </div>
        </div>
        <div className="shopper-approve-card__divider shopper-approve-card__divider--hide-mobile" />
        <ShopperApproveRatingDistribution />
    </a>
)

const ShopperApproveCardMobile = () => (
    <a href="https://www.shopperapproved.com/reviews/15622" target="_blank" className="shopper-approve-card shopper-approve-card--mobile">
        <div className="shopper-approve-card__image">
            <img src={SHOPPER_APPROVE_LOGO} alt="Shopper Approved" />
        </div>
        <div className="shopper-approve-card__divider" />
        <div className="shopper-approve-card__content">
            <div className="shopper-approve-card__score">
                4.7 <span>/ 5</span>
            </div>
            <div className="shopper-approve-card__stars">
                <ShopperApproveStars />
            </div>
            <p className="shopper-approve-card__reviews-count">Based on 159k+ Reviews</p>
        </div>
        <div className="shopper-approve-card__divider shopper-approve-card__divider--hide-mobile" />
        <ShopperApproveRatingDistribution />
    </a>
)

const ShopperApproveCard = () => (
    <div className="shopper-approve-card__container">
        <ShopperApproveCardDesktop />
        <ShopperApproveCardMobile />
    </div>
);

export default ShopperApproveCard;
